import actionTypes from 'user/actions/linked-retailers.action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_LINKED_RETAILERS_SUCCESS:
      return [...action.list];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/reducers/linked-retailers/list.js